import api from '../api/axios';

export interface Attendance {
  id?: number;
  employee: number;
  date: string;
  clockIn: string;
  clockOut?: string;
  status?: 'present' | 'absent' | 'late' | 'halfDay';
  notes?: string;
  workHours?: number;
  overtimeHours?: number;
  location?: string;
}

const AttendanceService = {
  getAll: (params?: any) => api.get('/attendances', { params }),
  getOne: (id: number, params?: any) => api.get(`/attendances/${id}`, { params: params || { populate: 'employee' } }),
  create: (data: Attendance) => api.post('/attendances', { data }),
  update: (id: number, data: Partial<Attendance>) => api.put(`/attendances/${id}`, { data }),
  delete: (id: number) => api.delete(`/attendances/${id}`),
  getByEmployee: (employeeId: number, params?: any) =>
    api.get('/attendances', {
      params: { ...params, 'filters[employee][id][$eq]': employeeId },
    }),
};

export default AttendanceService;

